import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';
import { CanDeactivateGuard } from '../shared/deactivate-guard/deactivate.guard';

export const centralBookingRoutes: Routes = [
  {
    path: 'search-client',
    loadComponent: () =>
      import('./search-client/search-client.component').then(
        (m) => m.SearchClientComponent
      ),
    canActivate: [AuthGuard],
  },
];
